import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            aria-label="九九免费视频首页"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-circle-fill text-background-50 text-xl"></i>
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-heading font-bold text-lg text-foreground-900">
                九九视频
              </span>
              <span className="text-[10px] text-foreground-500 font-label tracking-wide">
                FREE VIDEO
              </span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === '/'
                  ? 'bg-primary-100/70 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100/70 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-100/70 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-600 text-base"></i>
            </button>
            <Link
              to="/about"
              className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
            >
              联系我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-700 text-lg`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 space-y-1">
          <Link to="/" className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100">首页</Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100"
            >
              {cat.name}
            </Link>
          ))}
          <Link to="/about" className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100">关于我们</Link>
        </div>
      )}
    </nav>
  );
}